import React from 'react'

type DeviceOptions = { 'audio':MediaDeviceInfoMediaDeviceSelection[],'video':MediaDeviceInfoMediaDeviceSelection[] }

const checkPermissions = async (
  checks:{ 'audio':Promise<PermissionState> | undefined,'video':Promise<PermissionState> | undefined }
) : Promise<DeviceOptions | undefined> => {
  try
  {
    const stream = await navigator.mediaDevices.getUserMedia({
      'video':!!checks.video,
      'audio':!!checks.audio,
    })
    const [permissionAudio,permissionVideo,devices] = await Promise.all([
      checks.audio,
      checks.video,
      navigator.mediaDevices.enumerateDevices(),
    ])
    console.log('checkPermissions.result',[permissionAudio,permissionVideo,devices])
    stream.getTracks().forEach((x) => x.stop()) // TODO: if checkPermissions is called while still holding the stream/tracks from the previous call, can fail with "Not Readable"
    if([permissionAudio,permissionVideo].every((x) => x == 'granted' || x == undefined))
    {
      return {
        'audio':devices.filter((x) => x.kind === 'audioinput').map((x) => ({ 'deviceId':x.deviceId,'label':x.label,'device':x })),
        'video':devices.filter((x) => x.kind === 'videoinput').map((x) => ({ 'deviceId':x.deviceId,'label':x.label,'device':x })),
      }
    }
    else
    {
      return undefined
    }
  }
  catch(e)
  {
    console.error(e)
    return undefined
  }
}

type MediaDeviceKind = 'microphone' | 'camera'
export type MediaDeviceInfoMediaDeviceSelection = {
  deviceId:string
  label:string
  device:MediaDeviceInfo
}

export const useMediaDevices = (...xs:MediaDeviceKind[]) : [() => Promise<DeviceOptions | undefined>] => {
  const [stateKinds,setKinds] = React.useState(xs)
  React.useEffect(() => {
    if(xs.toSorted().join(';') !== stateKinds.toSorted().join(';'))
    {
      console.log('useMediaDevices.useEffect.changed')
      setKinds(xs)
    }
  },[xs])
  return React.useMemo(() => (console.log('useMediaDevices.useMemo'),[
    () => (console.log('useMediaDevices.check'),checkPermissions({
      'audio':xs.includes('microphone') ? (async () => (await navigator.permissions.query({ 'name':'microphone' })).state)() : undefined,
      'video':xs.includes('camera')     ? (async () => (await navigator.permissions.query({ 'name':'camera' })).state)()     : undefined,
    })),
  ]),[stateKinds])
}

export default useMediaDevices
